/* eslint-disable max-len, max-lines, no-undef, react/destructuring-assignment, react/no-unused-state, sort-keys, sort-vars */
/* eslint-disable consistent-return */

import MobileSort from "./MobileSort";
import PropTypes from "prop-types";
import React from "react";
import ToolTip from "../../../shared/components/ToolTip";
import {clearAllFilters} from "../../../actions";
import {connect} from "react-redux";

class Filters extends React.Component {

  static propTypes = {
    "categories": PropTypes.array.isRequired,
    "clearAllFilters": PropTypes.func.isRequired,
    "doFilter": PropTypes.func.isRequired,
    "excludeTrendsFromFilter": PropTypes.bool,
    "filters": PropTypes.array.isRequired,
    "handleClick": PropTypes.func.isRequired,
    "handleTooltipClose": PropTypes.func.isRequired,
    "isMobile": PropTypes.bool.isRequired,
    "params": PropTypes.object.isRequired,
    "previewSwapping": PropTypes.bool.isRequired,
    "selectedFilters": PropTypes.array.isRequired,
    "showClearancePrice": PropTypes.bool.isRequired,
    "showPriceRangeFilters": PropTypes.bool.isRequired,
    "showPromoFilters": PropTypes.bool.isRequired,
    "showToolTip": PropTypes.bool.isRequired,
    "showTrendFilters": PropTypes.bool.isRequired,
    "sort": PropTypes.func.isRequired,
    "sorts": PropTypes.array.isRequired,
    "stickyFilter": PropTypes.object,
    "toggleMobileFilters": PropTypes.func.isRequired
  };

  static defaultProps = {
    "excludeTrendsFromFilter": false,
    "stickyFilter":
      {
        "class": "sticky-filter-default",
        "scrollHeight": 400
      }
  }

  constructor (props) {
    super(props);
    this.state = {"selectedNonFilterTrend": null};
    this.handleScroll = this.handleScroll.bind(this);
  }

  componentDidMount () {
    window.addEventListener("scroll", this.handleScroll);
  }

  componentWillReceiveProps () {
    this.getSelectedNonFilterTrend();
  }

  componentWillUnmount () {
    window.removeEventListener("scroll", this.handleScroll);
  }

  handleKeyDown = (event) => {
    if (event.keyCode === 13) {
      this.props.handleClick(event);
    }
  }

  handleScroll () {
    this.setState({"scroll": window.scrollY});
  }

  toggleFiltersDisplay = (event) => {
    const target = event.currentTarget;
    const querySelector = target.attributes["data-target"].value;

    $(target).toggleClass("bold");
    $(querySelector).slideToggle();
    $(target).children(".expand-btn, .collapse-btn").toggleClass("expand-btn collapse-btn");
  }

  mapFiltersToProperty = (filters, propName) =>
    filters.reduce((result, filter) => {
      if (filter[propName]) {
        return result.concat(filter[propName]);
      }
      return result;
    }, []);

  resetFilters = () => {
    const {clearAllFilters} = this.props; // eslint-disable-line no-shadow
    clearAllFilters();
  }

  renderSubCategories = (selection, selectedKeys) =>
    (
      <div
        className="sub-selections ml16"
        id={`subSelections${selection.slug}`}
      >
        {selection.subCategories.map(subCategory =>
          (
            <div
              className={selectedKeys.includes(subCategory.key) ? "styled_h7 subSelection ttcommons-demibold" : "styled_h7 subSelection"}
              id={subCategory.key}
              key={subCategory.key}
              onClick={this.props.handleClick}
              onKeyDown={this.handleKeyDown}
              showifselected={selection.showIfSelected}
              title={subCategory.name}
            >
              {subCategory.name}
              {selectedKeys.includes(subCategory.key) ? <span className="filter-check" /> : ""}
            </div>
          ))}
      </div>
    );

  getSelectedNonFilterTrend = () => {
    const {filters, selectedFilters} = this.props;

    if (!selectedFilters) return;

    const selectedTrend = selectedFilters.find(filter => filter.key.includes("trends-"));

    if (!selectedTrend) return;

    const matchedTrend = filters.find(filter => filter.key === "trends").selections.find(selection => selection.key === selectedTrend.key);

    if (!matchedTrend) return;

    this.setState({"selectedNonFilterTrend": matchedTrend.display_in_filters ? null : matchedTrend});
  }

  filterSection = (filterType) => {
    const {excludeTrendsFromFilter, isMobile, selectedFilters} = this.props;
    const {selectedNonFilterTrend} = this.state;
    const selectedKeys = selectedFilters.map(filter => filter.key);
    const isColor = filterType.key === "colors";
    const isSwatch = isColor || filterType.key === "size";
    const isTrend = filterType.key === "trends";
    const isOnClearance = window.location.pathname.includes("clearance");
    const openByDefault = [
      "kinds",
      "my_rocksbox",
      "holiday_shop",
      "trends",
      "size",
      "length"
    ];
    if (isTrend && excludeTrendsFromFilter) {
      return;
    }
    // Remove the code below after Black Friday
    if (isOnClearance) {
      openByDefault.push("price");
      openByDefault.shift();
    }
    const collapseByDefault =
      isMobile || !openByDefault.includes(filterType.key);
    const nbOfSelectedForType = selectedKeys.filter(filKey => filterType.key.includes(filKey.split("-")[0])).length - (selectedNonFilterTrend ? 1 : 0);

    if (filterType.defaultHide &&
      !this.
        mapFiltersToProperty(selectedFilters, "showIfSelected").
        some(sel => sel.includes(filterType.key))) {
      return;
    }
    return (
      <div
        className={`pv16 type ${filterType.slug}`}
        key={filterType.slug}
      >
        <div
          className={`${collapseByDefault ? "type-title" : "type-title bold"} styled_h6`}
          data-target={`#collapse${filterType.slug}`}
          id={filterType.key}
          onClick={this.toggleFiltersDisplay}
        >
          {filterType.title}
          <div className="inline">
            {nbOfSelectedForType > 0 ? ` (${nbOfSelectedForType})` : ""}
          </div>
          <span
            className={collapseByDefault ? "expand-btn" : "collapse-btn"}
          />
        </div>
        <div
          className="selections"
          id={`collapse${filterType.slug}`}
          style={{"display": collapseByDefault ? "none" : ""}}
        >
          {filterType.selections.map((selection) => {
            const isNonFilterDisplay = isTrend && !selection.display_in_filters;
            const isSelected = selectedKeys.includes(selection.key);
            let className = isSelected ? "selection-title ttcommons-demibold" : "selection-title";
            if (isColor) {
              className += ` sprite-${selection.key}`;
            }
            return (
              <div
                className={`${isSelected ? "selection selected" : "selection"}${isNonFilterDisplay ? " hidden" : ""}`}
                key={selection.key}
              >
                <div
                  className={`${className} styled_h6`}
                  data-target={`#subSelections${selection.slug}`}
                  id={selection.key}
                  onClick={this.props.handleClick}
                  onKeyDown={this.handleKeyDown}
                  showifselected={selection.showIfSelected}
                  tabIndex="0"
                  title={selection.name}
                >
                  {isColor ? "" : selection.name}
                  {isSelected && !isSwatch ? <span className="filter-check" /> : ""}
                  {!isSelected && !isSwatch && selection.subCategories &&
                    <span className="" />}
                </div>
                {selection.subCategories &&
                  selectedKeys.includes(selection.key) &&
                  this.renderSubCategories(selection, selectedKeys)}
              </div>
            );
          })}
        </div>
      </div>
    );
  }

  renderMobileButtons = () => {
    const {isMobile, toggleMobileFilters} = this.props;

    if (!isMobile) {
      return null;
    }

    return (
      <div className="mobile-filters-buttons">
        <div className="btn-background">
          <button
            className="apply-btn btn-primary"
            data-target=".toggle-filters"
            onClick={toggleMobileFilters}
            type="button"
          >
            Apply
          </button>
          <button
            className="reset-btn btn-secondary"
            data-target=".toggle-filters"
            onClick={this.resetFilters}
            type="button"
          >
            Reset
          </button>
        </div>
      </div>
    );
  };

  render () {
    const {
      filters,
      handleTooltipClose,
      isMobile,
      previewSwapping,
      selectedFilters,
      showToolTip,
      sort,
      sorts,
      stickyFilter,
      toggleMobileFilters
    } = this.props;
    const {selectedNonFilterTrend} = this.state;
    const nbOfSelectedFilters = selectedFilters.filter(fil => !(fil.key.indexOf("sort") === 0)).length - (selectedNonFilterTrend ? 1 : 0);

    return (
      <div
        className={this.state.scroll > stickyFilter.scrollHeight && !isMobile
          ? `sticky-filter-default ${stickyFilter.class}`
          : "filter-button-container"
        }
      >
        {isMobile &&
          <div
            className="filters-button pv16 ml16"
            data-target=".toggle-filters"
            onClick={toggleMobileFilters}
          >
            <span className="styled_h5">
              Filter
            </span>
            {nbOfSelectedFilters > 0 &&
              <div className="filter-count inline">
                {nbOfSelectedFilters}
              </div>
            }
          </div>
        }
        <div className="toggle-filters">
          <div>
            <div
              className="filters left"
              id="filters-block"
            >
              <div className="first-filter-block pt0 pl0">
                <span className="filters-section-title styled_h5 mt0">
                  Filter
                </span>
              </div>
              {!isMobile && previewSwapping &&
                <ToolTip
                  arrowPosition="left"
                  color="grey"
                  content="Explore filter options here"
                  handleTooltipClose={handleTooltipClose}
                  showToolTip={showToolTip}
                />
              }
              {isMobile &&
                <MobileSort
                  sort={sort}
                  sorts={sorts}
                />
              }
              {filters.map(filterType => this.filterSection(filterType))}
            </div>
            {this.renderMobileButtons()}
          </div>
          {isMobile &&
            <div
              className="filters-gray-bg"
              data-target=".toggle-filters"
              onClick={toggleMobileFilters}
            />
          }
        </div>
      </div>
    );
  }
}

const mapStoreToProps = state => ({"selectedFilters": state.selectedFilters || []});

export default connect(mapStoreToProps, {clearAllFilters})(Filters);
